import styles from './ButtonStaking.module.scss'
function Button({children,onClick,className}){
    return(
        <div className={styles.button + " "+className} onClick={onClick}>{children}</div>
    )
}
export default Button;